export const invalidPlayers = [
  // STK
  "Charlie BANFIELD",
  "Eamonn ARMSTRONG",
  "Kye FINCHER",
  "Liam O'CONNELL",

  // ADE
  "Mitchell MARSH",
  "Indy COTTON",
  "Archie LUDOWYKE",

  // CAR
  "Jack ISON",
  "Harry DEAN",
  "Talor BYRNE",

  // COL
  "Tyan PRINDABLE",
  "Sam SWADLING",

  // ESS
  "Jacob FARROW",
  "Sullivan ROBEY",
  "Dyson SHARP",
  "Max KONDOGIANNIS",
  "Hussien EL ACHKAR",

  // FRE
  "Tobyn MURRAY",
  "Adam SWEID",
  "Leon KICKETT",
  "Toby WHAN",
  "Ryda LUKE",

  // GEE
  "Hunter HOLMES",
  "Jesse MELLOR",
  "Harley BARKER",
  "Nicholas DRISCOLL",


  // GWS
  "Jayden LAVERDE",
  "Oskar TAYLOR",
  "Riley HAMILTON",
  "Finnegan DAVIS",

  // HAW
  "Cameron NAIRN",
  "Aidan SCHUBERT",
  "Matthew LERAY",
  "Jack DALTON",
  "Oliver GREEVES",

  // MEL
  "Xavier TAYLOR",
  "Thomas MATTHEWS",
  "Latrelle PICKETT",
  "Kalani WHITE",
  "Oscar BERRY",
  "Riley ONLEY",

  // NM
  "Lachy DOVASTON",
  "Blake THREDGOLD",
  "Hugo MIKUNDA",

  // PA
  "Jack WATKINS",

  // RIC
  "Sam CUMMING",
  "Sam GRLJ",
  "Zane PEUCKER",
  "Noah ROBERTS-THOMSON",

  // SYD
  "Jevan PHILLIPOU",
  "Billy COOTEE",
  "Harry KYLE",
  "Liam HETHERTON",
  "Noah CHAMBERLAIN",

  // WCE
  "Willem DUURSMA",
  "Josh LINDSAY",
  "Sam ALLEN",
  "Cooper DUFF-TYTLER",
  "Tylah WILLIAMS",
  "Fred RODRIGUEZ",
  "Deven ROBERTSON",
  "Finley MACRAE",
  "Harry SCHOENBERG",

  // WB
  "Lachlan CARMICHAEL",
  "Will DARCY",
  "Louis EMMETT",

  // BRI
  "Daniel ANNABLE",
  "Koby EVANS",
  "Cody CURTIN",
  "Ben MURPHY",
  "Tai HAYES",

  // GCS
  "Dylan PATTERSON",
  "Zeke UWLAND",
  "Jai MURRAY",
  "Beau ADDINSALL",
  "Avery THOMAS",
  "Koby COULSON"
];
